/* 
引入swiper相关的库
*/
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/css/swiper.css'

// 声明使用/安装插件   ==>   就能得到内部提供的一些特性(新的组件)
Vue.use(VueAwesomeSwiper,/* {default options with global component} */)